"use client";

import { ArrowRight } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TechnologyPillars() {
  const {
    ref: sectionRef,
    isVisible: sectionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.1
  });
  const pillars = [{
    number: "01",
    title: "Research & Innovation",
    description: "Cutting-edge research in construction technologies, leveraging expertise from the National University of Civil Engineering to develop sustainable and efficient solutions."
  }, {
    number: "02",
    title: "Technology Transfer",
    description: "Seamless integration of advanced technical solutions into real-world construction projects, ensuring innovation meets practical application."
  }, {
    number: "03",
    title: "Digital Transformation",
    description: "Comprehensive consulting services to modernize construction processes, optimize workflows, and implement smart construction technologies."
  }];
  return <section id="trụ-cột-công-nghệ" ref={sectionRef} className="dark bg-background text-foreground py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className={`text-center mb-16 transition-all duration-700 ${sectionVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl sm:text-5xl font-bold mb-4 text-primary">
            Technology Pillars
          </h2>
          <p className="text-muted-foreground text-lg max-w-3xl mx-auto">
            Three foundational pillars driving innovation and excellence in construction technology
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {pillars.map((pillar, i) => {
          const {
            ref: cardRef,
            isVisible: cardVisible
          } = useRevealOnScroll({
            once: true,
            threshold: 0.2
          });
          return <div key={i} data-index={i} ref={cardRef} className={`transition-all duration-700 ${cardVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: `${i * 150}ms`
          }}>
                <Card className="group h-full border-2 border-border bg-card hover:border-primary hover:shadow-[0_0_20px_rgba(0,190,240,0.3)] transition-all duration-300 relative overflow-hidden">
                  <CardHeader className="pb-4">
                    <div className="text-8xl font-bold mb-4 text-transparent bg-clip-text bg-gradient-to-br from-primary to-primary/50 opacity-20 group-hover:opacity-40 transition-opacity duration-300">
                      {pillar.number}
                    </div>
                    <CardTitle className="text-2xl font-bold text-foreground group-hover:text-primary transition-colors duration-300">
                      {pillar.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-6">
                    <p className="text-muted-foreground leading-relaxed">
                      {pillar.description}
                    </p>
                    <div className="overflow-hidden">
                      <div className="transform translate-x-[-100%] opacity-0 group-hover:translate-x-0 group-hover:opacity-100 transition-all duration-300">
                        <Button variant="ghost" className="text-primary hover:bg-primary/10 p-0 h-auto" asChild>
                          <Link to="#" className="flex items-center gap-2">
                            <span className="font-semibold">Learn More</span>
                            <ArrowRight className="size-4" />
                          </Link>
                        </Button>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}